import React, { useMemo } from 'react';
import { useListBrowserUtils } from '@ts-private/list-browser';
import { metadataStore } from '../metadataStore';
import { useTranslation } from 'react-i18next';
import { TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import { RoundedHeaderTableRow, ThemedHeaderTableCell } from 'components/common/table/TableStyles';
import WrappedFakeText from 'components/common/WrappedFakeText';
import { MetadataDetailTable, MetadataDetailTableContainer } from '../Styles';
import MetadataDetailListComponent from './MetadataDetailListComponent';

const MetadataDetailsListContainer = () => {
  const { t } = useTranslation();
  const { store } = useListBrowserUtils(metadataStore);

  const columns = useMemo(() => {
    const result = [
      { caption: t('Metadata.Name') },
      { caption: t('Metadata.Code') },
      { caption: t('Metadata.DataType') },
      { caption: t('Metadata.Entity') },
      { caption: t('Actions'), align: 'right', width: '100px' }
    ];
    return result;
  }, [t]);

  const loading = useMemo(() => !store.initialized || store.loading, [store.initialized, store.loading]);

  return (
    <MetadataDetailTableContainer mt={2}>
      <MetadataDetailTable>
        <TableHead>
          <RoundedHeaderTableRow>
            {columns.map((column, index) => (
              <ThemedHeaderTableCell key={`${index}-${column}`} align={column.align} title={column.caption} width={column.width}>
                {column.caption}
              </ThemedHeaderTableCell>
            ))}
          </RoundedHeaderTableRow>
        </TableHead>
        <TableBody>
          {loading && (
            <TableRow>
              <TableCell colSpan={columns.length}>
                <WrappedFakeText />
              </TableCell>
            </TableRow>
          )}
          {!loading && <MetadataDetailListComponent columnsLength={columns.length} />}
        </TableBody>
      </MetadataDetailTable>
    </MetadataDetailTableContainer>
  );
};

export default MetadataDetailsListContainer;
